'use client'

import styled, { css } from 'styled-components'
import { desktop } from 'ui/src/css'
import { CloseIcon as _CloseIcon } from 'ui/src/icons/navigation'

export const OuterContainer = styled.div`
    display: flex;
    height: 70vh;
    ${desktop(css`
        height: 100vh;
        width: 50vw;
    `)}
`
export const Container = styled.div`
    position: relative;
    display: flex;
    align-items: stretch;
    flex-direction: column;
    width: 325px;
    margin: auto;
    gap: 12px;
    h3 {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 10px;
    }
`

export const Logo = styled.img`
    margin: 0 auto;
    ${desktop(css`
        width: 320px;
        height: 150px;
    `)}
    width: 195px;
    height: 92px;
`

export const CloseIcon = styled(_CloseIcon)`
    align-self: flex-start;
    margin-top: 10px;
    position: absolute;
    inset: 0;
    display: block;
    ${desktop(css`
        display: none;
    `)}
`
